module.exports = __webpack_public_path__ + "img/background.abc3d72a.png";